import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-plan-switcher',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './plan-switcher.component.html',
  styleUrls: ['./plan-switcher.component.css']
})
export class PlanSwitcherComponent implements OnInit {
  readonly isSuperAdmin = environment.isSuperAdmin;

  isDropdownOpen = false;
  isEssential = false;
  hasFormWizSubscription = false;
  hasNormalSubscription = false;
  hasBothSubscriptions = false;
  spUser: any;

  constructor(private eRef: ElementRef, private router: Router) {}

  ngOnInit() {
    this.setPlanFromSubscription();

    // Re-evaluate on navigation in case sp-user/subscription context changes.
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.setPlanFromSubscription();
      });
  }

  // ✅ Toggle dropdown
  togglePlanSwitcher(event: Event) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  // ✅ Close when clicking outside
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen = false;
    }
  }

  setPlanFromSubscription() {
    if (this.isSuperAdmin) {
      this.hasFormWizSubscription = true;
      this.hasNormalSubscription = true;
      this.hasBothSubscriptions = true;
    } else {
      const spUser = localStorage.getItem('sp-user');
      this.spUser = spUser ? JSON.parse(spUser) : null;
      this.hasFormWizSubscription = this.spUser?.hasFormWizSubscription === true;
      this.hasNormalSubscription = this.spUser?.hasNormalSubscription === true;
      this.hasBothSubscriptions = this.hasFormWizSubscription && this.hasNormalSubscription;
    }

    this.isEssential =
      (!this.hasFormWizSubscription && this.hasNormalSubscription) ||
      (this.hasFormWizSubscription && this.hasNormalSubscription);
  }
}